/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const MAP_PIN_VIEWBOX = 24;

const MAP_PIN_PATH = 'M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Map pin / location marker outline (24×24). Color via `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const MapPinIcon = ({
  size = 20,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${MAP_PIN_VIEWBOX} ${MAP_PIN_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={MAP_PIN_PATH} stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <circle cx="12" cy="11" r="2.25" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

MapPinIcon.propTypes = iconPropTypes;

export { MapPinIcon };
export default MapPinIcon;
